module.exports = __webpack_public_path__ + "img/3445875-1.195986a9.jpg";